<template>
  <div>
    <div class="c-application-appartment">
      <button v-if="url" class="c-button c-button--icon c-button--highlight" @click="toggleModalStep2">
          <span class="c-application-appartment--decoy"></span>
          <span class="c-button--right">{{buttonTexts.applyText}}</span>
          <span class="c-application-appartment--scale">
            <v-icon name="icon-arrow" :cssModifiers="whiteIcon+ ' arrow-icon--padding'" size="s" />
          </span>
      </button>

      <button
		  	v-if="showKeepUpdatedButton === '1'" target="_blank"
			  :class="['c-button', 'c-button--icon',
				  showKeepUpdatedButtonHighlighted === '1'
				  	? 'c-button--highlight'
				  	: 'c-button--secondary'
			  ]"
			  @click="toggleModalUpdateOnly">
          <span class="c-application-appartment--decoy"></span>
          <span class="c-button--right">{{buttonTexts.keepUpdatedText}}</span>
          <span class="c-application-appartment--scale c-application-appartment--padding">
            <v-icon name="icon-arrow" :cssModifiers="whiteIcon+ ' arrow-icon--padding'" size="s" />
          </span>
      </button>
      <div class="c-application-appartment-container">
        <a v-if="infoUrl" class="c-application-appartment-link" target="_blank" :href="infoUrl">{{buttonTexts.infoText}}</a>
      </div>
    </div>

    <v-modal
      v-if="showModal"
      :close="toggleModal"
    >
      <template v-slot:content>
        <!-- This is first step of modal. -->
        <div v-if="!stepOneCompleted" class="c-application-modal-content">
          <div class="c-application-modal-content-container">
            <h2 class="c-application-modal-content-title">{{modalPartOne.heading}}</h2>
            <p class="c-application-modal-content-subtitle">{{modalPartOne.subHeading}}</p>
            <p class="c-application-modal-content-text">{{modalPartOne.text}}.</p>
          </div>

          <form
            class="c-application-modal-form"
            method="post"
            v-on:submit="handleSubmit"
          >
            <div class="c-application-modal-form-input--container">
              <input
                type="text"
                ref="textfield"
                :placeholder="mFormPlaceholders.name"
                :required="true"
                v-model="formData.name"
              />
            </div>

            <div class="c-application-modal-form-input--container">
              <input
                type="email"
                :placeholder="mFormPlaceholders.email"
                :required="!formData.phone"
                v-model="formData.email"
              />
            </div>

            <div class="c-application-modal-button-container">
              <div class="c-application-appartment-container">
                <button @click='toggleModal' type="button" class="c-application-appartment-button--link" target="_blank">{{mOneButtons.cancelButtonText}}</button>
              </div>
              <button class="c-button c-button--icon c-button--highlight" type="submit">
                <span class="c-button--right">{{url && !updateOnly ? mOneButtons.nextButtonText : mOneButtons.nextButtonTextAlternative}}</span>
                <span class="c-application-appartment--scale c-application-appartment--padding">
                  <v-icon name="icon-arrow" :cssModifiers="whiteIcon+ ' arrow-icon--padding'" size="s" />
                </span>
              </button>
            </div>
          </form>
        </div>

        <!-- This is step two of modal. -->
        <div class="c-application-modal-content" v-if="stepOneCompleted && url && !updateOnly && !apiError.error">
          <div class="c-application-modal-content-container">
            <h2 class="c-application-modal-content-title">{{modalPartTwo.heading}}</h2>
            <p class="c-application-modal-content-subtitle">{{modalPartTwo.subHeading}}</p>
            <p class="c-application-modal-content-text">{{modalPartTwo.text}}</p>
          </div>
          <template v-for="(step, index) of stepTexts">
            <div v-bind:key="index" class="c-application-modal-container">
              <div class="c-application-modal-step-container--left">

                <div class="c-application-modal__circle">
                    <p class="c-application-modal__circle-text">{{step.number}}</p>
                </div>
                <div v-if="index !== stepTexts.length - 1" class="c-application-modal__line"></div>
              </div>
              <div class="c-application-modal-step-container--right">
                <p class="c-application-modal-content-subtitle">{{step.stepSubHeading}}</p>
                <p class="c-application-modal-content-text">{{step.text}}.</p>
              </div>
            </div>
          </template>
          <div class="c-application-modal-container--column">
            <div class="c-application-modal-bottom-container">
              <a class="c-application-appartment-link" target="_blank" :href="mTwoLinks.explainLink">{{mTwoLinks.explainLinkText}}</a>
              <a class="c-application-appartment-link" target="_blank" :href="mTwoLinks.processInfoLink">{{mTwoLinks.processInfoLinkText}}</a>
            </div>
            <div class="c-application-modal-button-container">
              <a @click="toggleUpdate" target="_blank" :href="url" class="c-button c-button--icon c-button--highlight">
                {{mTwoLinks.button}}
                <span class="c-application-appartment--scale c-application-appartment--padding">
                  <v-icon name="icon-arrow" :cssModifiers="whiteIcon+ ' arrow-icon--padding arrow-icon--negmargin'" size="s" />
                </span>
              </a>

            </div>
          </div>
        </div>

        <!-- This is content when application i sent. -->
        <div class="c-application-modal-content" v-if="stepOneCompleted && updateOnly && !apiError.error">
          <div class="c-application-modal-content-container">
            <h2 class="c-application-modal-content-title">{{modalPartTwo.heading}}</h2>
            <p class="c-application-modal-content-text">{{modalDone}}</p>
          </div>
        </div>
        <!-- This is error msg, if API call fails. -->
        <div class="c-application-modal-content" v-if="stepOneCompleted && apiError.error">
          <div class="c-application-modal-content-container">
            <h2 class="c-application-modal-content-title">{{apiError.errHeading}}</h2>
            <p class="c-application-modal-content-text">{{apiError.msg}}</p>
          </div>
        </div>
      </template>
    </v-modal>
  </div>
</template>

<script>
import VIcon from '../../components/icon/VIcon';
import VModal from '../../components/modal/VModal';
import axios from "axios";

export default {
  name: 'VAppartmentApplication',
  components : {
    VIcon,
    VModal
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    modalPartOne: {
      type: Object,
      default: () => {}
    },
    modalPartTwo: {
      type: Object,
      default: () => {}
    },
    mFormPlaceholders: {
      type: Object,
      default: () => {}
    },
    mOneButtons:{
      type: Object,
      default: () => {}
    },
    mTwoLinks: {
      type: Object,
      default: () => {}
    },
    stepTexts: {
      type: Array,
      default: () => []
    },
    modalDone: {
      type: String,
      default: ''
    },
    objectId: {
      type: String,
      default: ''
    },
    infoUrl: {
      type: String,
      default: ''
    },
    apiUrl: {
      type: String,
      default: ''
    },
    buttonTexts: {
      type: Object,
      default: () => {}
    },
    showKeepUpdatedButton: {
      type: String,
      default: "0"
    },
    showKeepUpdatedButtonHighlighted: {
		  type: String,
		  default: "0"
    }
  },
  data() {
    return {
      whiteIcon: "c-icon--white",
      showModal: false,
      formData: {
        name: '',
        email: '',
      },
      stepOneCompleted: false,
      updateOnly: false,
      apiError: {
        error: false,
        errHeading: "Fel har inträffat",
        msg: 'Ansökan har inte skickats då ett fel har inträffat. Kontakta websidans administratör samt testa att ladda om sidan.'
      }

    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      //Anropet till backend om valideringen är rätt
      axios.post(`${this.apiUrl}&pf_SubscriberName=${this.formData.name}&pf_Email=${this.formData.email}`)
        .then(res => res)
        .catch(err => {
          this.apiError.error = true
          if (err.response) {
            if (err.response.status >= 400 && err.response.status < 500) {
              this.apiError.msg = "Din ansökan har inte skickats, något är fel med de inmatade uppgifterna. Ladda om sidan och testa igen."
            }
          }
        });
      if (this.updateOnly) {
        this.stepOneCompleted = true;

      }
      if (!this.updateOnly) {
        this.stepOneCompleted = true;
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
      if (this.showModal === true) {
        this.updateOnly = false;
        document.body.style.overflow = 'hidden';
      }
      if (this.showModal === false) {
        this.updateOnly = false;
        document.body.style.overflow = 'auto';
      }
    },
    toggleModalStep2() {
      this.stepOneCompleted = true;
      this.showModal = !this.showModal;
      if (this.showModal === true) {
        this.updateOnly = false;
        document.body.style.overflow = 'hidden';
      }
      if (this.showModal === false) {
        this.updateOnly = false;
        document.body.style.overflow = 'auto';
      }
    },
    toggleModalUpdateOnly() {
      this.updateOnly = true;
      this.stepOneCompleted = false;
      this.showModal = !this.showModal;
      if (this.showModal === true) {
        document.body.style.overflow = 'hidden';
      }
      if (this.showModal === false) {
        this.updateOnly = false;
        document.body.style.overflow = 'auto';
      }
    },
    toggleUpdate() {
      this.stepOneCompleted = true;
       this.showModal = !this.showModal;
      if (this.showModal === true) {
        this.updateOnly = false;
        document.body.style.overflow = 'hidden';
      }
      if (this.showModal === false) {
        this.updateOnly = false;
        document.body.style.overflow = 'auto';
      }
    },
    toggleNextStep() {
      this.stepOneCompleted = true;
    },
    close() {
      document.body.style.overflow = 'hidden';
    }
  }

}
</script>
